export default __webpack_public_path__ + "static/media/music.ea3b69a8.svg";